import type { ReactNode } from 'react';
import styles from './FormField.module.css';

export interface FormFieldProps {
	label: string;
	required?: boolean;
	error?: string;
	children: ReactNode;
}

export const FormField = (props: FormFieldProps) => {
	const { label, required, error, children } = props;
	const reservesSpace = 'error' in props;

	return (
		<div className={styles.field}>
			<label className={styles.label}>
				{label}
				{required && <span className={styles.asterisk}>*</span>}
			</label>
			{children}
			{reservesSpace && <span className={styles.errorText}>{error}</span>}
		</div>
	);
};
